<template>
    <v-card class="elevation-1 rounded-4"> 
        <v-toolbar flat height="60px" color="grey lighten-4">
            <div class="font-weight-bold subtitle-1">Select Management Context</div>
        </v-toolbar>
        <v-card-text class="text-xs-left">
            <v-alert :value="true" color="info" icon="info" outline class="mt-0">
                This requestor belongs to multiple teams. You are currently managing <b>{{ currentTeam }}</b>. 
                Please select the team associated with this specific request.
            </v-alert>  
            <v-data-table
                :headers="header"
                :items="teams"
                hide-actions
            >
                <template v-slot:items="props">
                    <tr @click="select(props.item)" class="clickable" title="Click to switch to this team">
                        <td>{{ props.item.name }}</td>
                        <td>{{ props.item.description }}</td>
                    </tr>
                </template>
            </v-data-table> 
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="mr-10">
            <v-spacer></v-spacer>
            <v-btn class="primary" dark @click="closeDialog">Cancel</v-btn>
        </v-card-actions>
    </v-card>
</template>
<script>

import { setSelectedTeam } from '@/helpers/team-selector'
export default {
    data () {
        return {
            loading: false,
            header: [
                {text: 'Team',align: 'left',value: 'name', width: '40%', sortable:true},
                {text: 'Description',align: 'left',value: 'description', width: '60%', sortable:true},
            ],
        }
    },
    props: ['teams'],
    methods: {
        select(team) {
            setSelectedTeam(team)
            this.closeDialog()
        },
        closeDialog() {
            this.$emit('update:dialogTeamSelector', false)
        }
    },
    computed: {
        currentTeam() {
            return this.$store.state.selectedTeamName
        }
    }
}
</script>